import { DatePipe } from '@angular/common';
import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from 'app/services/api.service';
import { SocketService } from 'app/services/socket.service';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
  selector: 'app-all-gates',
  templateUrl: './all-gates.component.html',
  styleUrls: ['./all-gates.component.css']
})
export class AllGatesComponent implements OnInit{
  Bstatus = 'Cancelled';
  color='';
  isPotrait:boolean = false;
  gates:any[]=[];
  gatesaray:any[] = [];
  spinner:boolean = false;
  sessionid;
  searchshow:boolean = false;
  Searchtext: any =''
  langconfig;
  prevlink:string = '';
  nextlink:string = '';
  sspinner:boolean = false;
  constructor(private apiService: ApiService,private router: Router, private devicedetails: DeviceDetectorService,private socketservice: SocketService) {
    this.checkorientation();
    this.apiService.language.subscribe((res)=>{
      const langcode = res.code
      this.langconfig = langcode == 'En' ? require("../../Language/En-us.json") : require("../../Language/It-us.json")
    })
   }

   @HostListener('window:resize', ['$event'])
   onResize(event: Event): void {
     this.checkorientation();
     // this.calldata();
   }
 

  ngOnInit() {
    sessionStorage.removeItem('sessionId');
    this.spinner = true;
    this.apiService.getallgates().subscribe(res =>{
        res.result.forEach((d)=>{
          this.gates.push(d);
          this.gatesaray.push(d);
        })
        this.prevlink = res.links.previous;
        this.nextlink = res.links.next
        this.spinner = false;
        this.socketservice.calldigitaltwine();
        this.callsocketdata();
    },(error)=>{
      this.spinner= false;
    })
  }

  checkorientation(){
    this.isPotrait = window.innerHeight < window.innerWidth ? true : false
  }

  videosrcfornewgates(gate){
    if(gate.boarding_percentage >= 90 || gate.status ==  'BOARDING MAY BE CLOSING'){
      return '../../../assets/images/bmore90.gif'
    }else if(gate.status == 'NO FLIGHT ASSIGNED TO THIS GATE' || gate.status ==  "NO INFORMATION AVAILABLE, PLEASE PROCEED TO YOUR GATE"){
      return '../../../assets/images/nof.gif'
    }else if(gate.boarding_percentage < 90 && gate.boarding_percentage){
      return '../../../assets/images/bless90.gif'
    }else if(gate && !gate.boarding_percentage || gate.status ==  'BOARDING NOT STARTED'){
      return '../../../assets/images/nob.gif'
    }
  }

  onscroll(event:any){
    if (event.target.offsetHeight + 5 + event.target.scrollTop >= event.target.scrollHeight && event.target.scrollTop && !this.sspinner) {
      this.sspinner = true;
      this.apiService.nextpagelinks(this.nextlink).subscribe((res)=>{
        res.result.forEach((d)=>{
          this.gates.push(d);
          this.gatesaray.push(d);
        })
        this.prevlink = res.links.previous;
        this.nextlink = res.links.next
        this.sspinner = false;
      })
    } 
  }


  callsocketdata(){
    this.apiService.digitaltwinDatae.subscribe((res)=>{
      if(res){
        const responce = JSON.parse(JSON.stringify(res['msg'])) 
        delete responce['publisher']
        const key = Object.keys(responce);
        const value = Object.values(responce);
        // this.gates = value;
        // this.gatesaray = value;
        // if(this.flightNo == key[0]){
        //   this.childData = value[0]
        // }
      }
    })
  }

  devicetype;
  source;
  medium;
  opengate(gate){
    const devicedetails = this.devicedetails.getDeviceInfo();
    const deviceres = window.innerHeight + '*' + window.innerWidth;
    const devicetype = this.devicedetails.isTablet() ? 'Tablet' : this.devicedetails.isMobile() ? 'Mobile' : this.devicedetails.isDesktop() ? 'Desktop' : 'Others';
    this.devicetype = devicetype
      sessionStorage.setItem('fromdevice',this.devicetype);
      this.source = 'bahome';
      sessionStorage.setItem('fromsource',this.source);
      sessionStorage.setItem('source', this.source);
      this.medium = 'weblink';
      sessionStorage.setItem('medium',this.medium);
    const param = {
      browser_name : devicedetails.browser,
      browser_version: devicedetails.browser_version,
      device_name: devicedetails.device,
      os_name: devicedetails.os,
      os_version: devicedetails.os_version,
      user_agent: devicedetails.userAgent,
      resolution: deviceres,
      device_type: devicetype,
      gate: gate.gate_no,
      device: this.devicetype ? this.devicetype : 'Undefined',
      source: this.source ? this.source : 'Undefined',
      medium: this.medium ? this.medium : 'Undefined',
    }
    this.spinner =true;
    this.apiService.gates_api(gate.gate_no).subscribe(response => {
      let flightcode = '';
            if(gate.flight_code.includes('BA')){              
              flightcode = gate.flight_code;
            }
          let responsedata = response.data.filter(item => item !== response.data[1])
            this.apiService.setSharedData(responsedata);  
            this.apiService.getsession(param).subscribe(res =>{
                if(res.id){
                  this.sessionid = res.id
                  this.spinner = false;
                  this.router.navigate(['/pax'],{ queryParams: { gateno: gate.gate_no, pax_view_session: this.sessionid } })
                  this.apiService.setsessionId('sessionId', this.sessionid,2);
                }
                this.spinner = false;
              },(error)=>{
                this.spinner = false;
              })
        },(error)=>{
          this.spinner = false;
        })   
  }
  searchactive:boolean = false;
  searchValue() {
    this.searchactive = false;
    if(!this.searchactive && this.Searchtext.length>0){
      let gatesarray = [];
      this.gates = this.gatesaray;
        this.gates.find(gate => {
          if (gate && (gate && gate.flight && gate.flight.toLowerCase().includes(this.Searchtext.toLowerCase())) || (gate && gate.gate_no && gate.gate_no.toLowerCase().includes(this.Searchtext.toLowerCase())) || (gate && gate.destination && gate.destination.toLowerCase().includes(this.Searchtext.toLowerCase()))) {
            gatesarray.push(gate);
          }
        })    
      this.gates = gatesarray && gatesarray[0] != undefined ? gatesarray : [];
      this.searchactive = true;
    }
  }

  clearsearch(){
    this.Searchtext = '';
    this.searchactive = false;
    this.gates = this.gatesaray;
  }

}
